// extracted by mini-css-extract-plugin
export var container = "_qv-0";
export var dotAnimation = "_qv-2";
export var dotsLoading = "_qv-1";